// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-pages-index-page-index-actions-content-collections-zolam{display:grid;grid-gap:24px}.components-pages-index-page-index-actions-content-collections-zolam.components-pages-index-page-index-actions-content-desktop-pzram{grid-template-columns:repeat(4,1fr)}.components-pages-index-page-index-actions-content-collections-zolam.components-pages-index-page-index-actions-content-mobile-uzvbs{grid-template-columns:repeat(2,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collections": "components-pages-index-page-index-actions-content-collections-zolam",
	"desktop": "components-pages-index-page-index-actions-content-desktop-pzram",
	"mobile": "components-pages-index-page-index-actions-content-mobile-uzvbs"
};
module.exports = ___CSS_LOADER_EXPORT___;
